import type { ButtonProps } from '@chakra-ui/react'
import { Button, useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { LdapUser } from 'brokertslib/src/dtos/User/LdapUser'
import { useGetLdapUser } from 'brokertslib/src/hooks/useOrganizationUnit'

import { Cloud } from '../../icons'

interface LoadLdapUserButtonProps extends ButtonProps {
  userName: string
  onLdapUserLoaded: (ldapUser: LdapUser) => void
}

export const LoadLdapUserButton = ({
  userName,
  onLdapUserLoaded,
  ...rest
}: LoadLdapUserButtonProps) => {
  const toast = useToast()
  const { mutateAsync: getLdapUser, isPending } = useGetLdapUser()

  const loadFromLdap = async () => {
    await getLdapUser(userName)
      .then((result) => {
        toast({
          title: 'Údaje byly načteny z LDAP',
          status: 'success',
        })

        onLdapUserLoaded(result.data)

        return result.data
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 404)
          return toast({
            title: 'Uživatel nebyl nalezen v LDAP',
            status: 'error',
          })

        console.error(e)
        toast({
          title: 'Uživatele nelze načíst z LDAP',
          description: e.response
            ? `${e.response.status}: ${e.response.statusText}`
            : e.message,
          status: 'error',
        })

        return e.cause ?? new Error('Unknown error')
      })
  }

  return (
    <Button
      onClick={loadFromLdap}
      isDisabled={!userName}
      isLoading={isPending}
      {...rest}
    >
      <Cloud color="secondary.500" />
      Načíst údaje z LDAP
    </Button>
  )
}
